import { Radio } from 'antd';
import { Field } from 'formik';
import styled from 'styled-components';

import { CREDIT_CARD_PAYMENT_METHOD } from 'constants/all';

const RadioGroup = Radio.Group;

const PaymentMethodRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  height: 50px;
  justify-content: space-around;
  margin-bottom: 10px;
`;

type CreditCardSelectorProps = {
  card: {
    brand: string;
    last4: string;
  };
};

const CreditCardSelector = ({ card }: CreditCardSelectorProps) => {
  return (
    <Field name="creditCardPaymentMethod">
      {({ field, form }) => (
        <PaymentMethodRadioGroup
          value={field.value}
          onChange={(e) => form.setFieldValue(field.name, e.target.value)}
        >
          <Radio value={CREDIT_CARD_PAYMENT_METHOD.EXISTING}>
            {card.brand} *{card.last4}
          </Radio>
          <Radio
            data-testid="new-payment-method"
            value={CREDIT_CARD_PAYMENT_METHOD.NEW}
          >
            New payment method
          </Radio>
        </PaymentMethodRadioGroup>
      )}
    </Field>
  );
};

export default CreditCardSelector;
